export default "__VITE_PUBLIC_ASSET__35152719__"